<template>
  <div id="card-resa-cancelled">
    <div class="col-lg-5 col-xs-8">
      <h3 class="merriweather-reg-26">Mes</h3>
      <h2 class="merriweather-reg-40 mb-5">Réservations annulées</h2>
    </div>
    <div class="reserved-lodgings mt-5" v-for='cancelled in this.cancelled'>
      <div class="col-lg-10 col-xs-12 offset-lg-2">
        <p class="raleway-reg-p13">Numéro de réservation <strong>N°{{cancelled.num}}</strong></p>
        <div class="card-product">
          <img :src="formatSource(cancelled)" :alt="cancelled.lodging.name">
          <div class="card-product-infos">
            <div class="basic-info">
              <p class="raleway-bold-p text-center">{{cancelled.checkin}} au {{cancelled.check_out}}</p>
              <p class="raleway-bold-p text-center">{{cancelled.duration}} nuits</p>
              <!-- <p class="raleway-bold-p text-center">_ personnes</p> -->
            </div>
            <div class="row row-des">
              <div class="col-7">
                <p class="raleway-bold-p cursor-pointer text-underline" @click="goToLodging(cancelled.lodging.slug)">{{cancelled.lodging.name}}</p>
                <p class="raleway-bold-p">{{cancelled.lodging.full_address}}</p>

                <!-- <p class="raleway-reg-p13"><br>dîner et massage offerts 1 chambre</p> -->
              </div>
              <div class="col-4 ml-3">
                <p class="raleway-bold-p">TOTAL {{cancelled.total.toFixed(2)}}€</p>
                <p class="raleway-reg-p13">Annulée</p>
              </div>
            </div>
          </div>
        </div>
        <p></p>
      </div>
    </div>
  </div>
</template>

<script>
  import fetcher from 'packs/shared/api.js';


  export default{
    name: 'card-resa-cancelled',
    data() {
      return {
        reservationsList: [],
        origin: window.location.origin,
        cancelled: null
      }
    },
    methods: {
      formatSource(cancelled) {
        if (cancelled.lodging.photo_banner) {
          return cancelled.lodging.photo_banner
        } else {
          return 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
        }
      },
      goToLodging(slug) {
        window.open(`/reservation-hotel/${slug}`, '_blank');
      },
      async fetchCancelledResa() {
        try {
          const response = await fetcher.get("/reservations")
          console.log('response', response)
          this.reservationsList = response.data
          console.log(this.reservationsList)
          await this.cancelledReservations()
        } catch(e) {
          console.error(e)
        }
      },
      cancelledReservations() {
        this.cancelled = this.reservationsList.filter((reservation) => {
          return reservation.cancel === true
        })
        return this.cancelled
      }
    },
   mounted() {
     this.fetchCancelledResa()
     }
  }
</script>
